import { useEffect } from "react";
import { Auth } from "aws-amplify";
import { useAppDispatch } from "../app/hook";
import { forgetLocation } from "../features/authentication/location-slice";
import { handleAuthRedirect } from "../utils/auth";

export const useSessionMonitor = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const checkSession = async () => {
      try {
        await Auth.currentSession();
      } catch {
        await Auth.signOut();
        dispatch(forgetLocation());
        handleAuthRedirect();
      }
    };

    const interval = setInterval(checkSession, 60000); // 1分毎チェック
    return () => clearInterval(interval);
  }, [dispatch]);
};